import { render, staticRenderFns } from "./addRetailerTermsModal.vue?vue&type=template&id=61ef0129"
import script from "./addRetailerTermsModal.vue?vue&type=script&lang=js"
export * from "./addRetailerTermsModal.vue?vue&type=script&lang=js"
import style0 from "./addRetailerTermsModal.vue?vue&type=style&index=0&id=61ef0129&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports